// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__9VzI0","savePackageButton":"ClientWallet_savePackageButton__1lT53"};